<template>
  <ul class="nav">
    <li class="nav-item">
      <a class="nav-link" @click="showMenuDefault"><i class="fas fa-angle-double-left"></i> {{$lang.Menu.Common.DefaultMenu}}</a>
    </li>

    <li class="divider"></li>

    <li class="nav-title">
      {{$lang.Menu.Section.Settings}}
    </li>
    <router-link class="nav-item nav-dropdown" :to="{ path: '/acessos'}" disabled v-if="hasRole(roles.MENU_ADMINISTRATION)">
      <li class="nav-item nav-dropdown" disabled>
        <button type="button" aria-expanded="false" class="nav-link nav-dropdown-toggle" @click="handleClick"><i class="fas fa-shield-alt"></i> {{$lang.Menu.Items.Access.Administration}}</button>
        <ul class="nav-dropdown-items">
          <li class="nav-item" v-if="hasRole(roles.RW_ADM_ACCOUNTS)">
            <router-link :to="{ name: 'Contas' }" class="nav-link" exact><i class="fa fa-caret-right"></i> {{$lang.Menu.Items.Access.Accounts}}</router-link>
          </li>
          <li class="nav-item" v-if="hasRole(roles.RW_ADM_GROUPS)">
            <router-link :to="{ name: 'Grupos' }" class="nav-link" exact><i class="fa fa-caret-right"></i> {{$lang.Menu.Items.Access.Groups}}</router-link>
          </li>
          <li class="nav-item" v-if="hasRole(roles.RW_ADM_GROUPS)">
            <router-link :to="{ name: 'GruposNotificacao' }" class="nav-link" exact><i class="fa fa-caret-right"></i> {{$lang.Menu.Items.Access.NotificationGroups}}</router-link>
          </li>
          <li class="nav-item" v-if="hasRole(roles.RW_ADM_PERMISSIONS) || hasRole(roles.RW_ADM_PERMISSIONS_PCI)">
            <router-link :to="{ name: 'Permissoes' }" class="nav-link" exact><i class="fa fa-caret-right"></i> {{$lang.Menu.Items.Access.Permissions}}</router-link>
          </li>
        </ul>
      </li>
    </router-link>
    <router-link class="nav-item nav-dropdown" :to="{ path: '/organizacao'}" disabled v-if="hasRole(roles.MENU_ADMINISTRATION)">
      <li class="nav-item nav-dropdown">
        <button type="button" aria-expanded="false" class="nav-link nav-dropdown-toggle" @click="handleClick"><i class="fas fa-sitemap"></i> {{$lang.Menu.Items.Organization.Organization}}</button>
        <ul class="nav-dropdown-items">
          <li class="nav-item" v-if="hasRole(roles.RW_ADM_PERMISSIONS)">
            <router-link :to="{ name: 'Empresa' }" class="nav-link" exact><i class="fa fa-caret-right"></i> {{$lang.Menu.Items.Organization.Company}}</router-link>
          </li>
          <li class="nav-item" v-if="hasRole(roles.RW_ADM_PERMISSIONS)">
            <router-link :to="{ name: 'Filiais' }" class="nav-link" exact><i class="fa fa-caret-right"></i> {{$lang.Menu.Items.Organization.Branch}}</router-link>
          </li>
          <li class="nav-item" v-if="hasRole(roles.RW_ADM_PERMISSIONS)">
            <router-link :to="{ name: 'Departamento' }" class="nav-link" exact><i class="fa fa-caret-right"></i> {{$lang.Menu.Items.Organization.Department}}</router-link>
          </li>
          <li class="nav-item" v-if="true">
            <router-link :to="{ name: 'CoordenadorRegional' }" class="nav-link" exact><i class="fa fa-caret-right"></i> {{$lang.Menu.Items.Organization.BranchCoordinator}}</router-link>
          </li>
        </ul>
      </li>
    </router-link>
    <router-link class="nav-item nav-dropdown" :to="{ path: '/pci'}" disabled v-if="hasRole(roles.RW_OPER_PCI_ADM)">
      <li class="nav-item nav-dropdown">
        <button type="button" aria-expanded="false" class="nav-link nav-dropdown-toggle" @click="handleClick"><i class="fas fa-table"></i> {{$lang.Menu.Items.PCI.Administration}}</button>
        <ul class="nav-dropdown-items">
          <li class="nav-item">
            <router-link :to="{ name: 'PCIPermissoesItem' }" class="nav-link" exact><i class="fas fa-shield-alt"></i> {{$lang.Menu.Items.Access.PCI.Items}}</router-link>
          </li>
          <li class="nav-item">
            <router-link :to="{ name: 'PCIPermissoesContrato' }" class="nav-link" exact><i class="fas fa-shield-alt"></i> {{$lang.Menu.Items.Access.PCI.Contracts}}</router-link>
          </li>
          <li class="nav-item">
            <router-link :to="{ name: 'PCIPermissoesDepartamento' }" class="nav-link" exact><i class="fas fa-shield-alt"></i> {{$lang.Menu.Items.Access.PCI.Departaments}}</router-link>
          </li>
          <li class="nav-item">
            <router-link :to="{ name: 'Layouts' }" class="nav-link"><i class="far fa-edit"></i> {{$lang.Menu.Items.PCI.Layouts}}</router-link>
          </li>
        </ul>
      </li>
    </router-link>
    <router-link tag="li" class="nav-item nav-dropdown" :to="{ path: '/acessos'}" disabled v-if="hasRole(roles.MENU_ADMINISTRATION)">
      <li class="nav-item nav-dropdown" v-if="hasRole(roles.MENU_ADMINISTRATION)">
        <button type="button" aria-expanded="false" class="nav-link nav-dropdown-toggle" @click="handleClick"><i class="fas fa-file-invoice-dollar"></i> {{$lang.Menu.Items.Configuration.Finance}}</button>
        <ul class="nav-dropdown-items">
          <li class="nav-item">
            <router-link :to="{ name: 'TipoDespesa' }" class="nav-link" exact><i class="fa fa-caret-right"></i> {{$lang.Menu.Items.Configuration.TypeExpense}} </router-link>
          </li>
          <li class="nav-item">
            <router-link :to="{ name: 'MotivoViagem' }" class="nav-link" exact><i class="fa fa-caret-right"></i> {{$lang.Menu.Items.Configuration.TravelReason}} </router-link>
          </li>
          <li class="nav-item">
            <router-link :to="{ name: 'GrupoReembolsoViagem' }" class="nav-link" exact><i class="fa fa-caret-right"></i> {{$lang.Menu.Items.Configuration.GroupRefundTravel}} </router-link>
          </li>
        </ul>
      </li>
    </router-link>
  </ul>
</template>
<script>
import Roles from '@/shared/utils/roles.js'
import AccountMixin from '@/store/module/account/mixin'
import CompanyMixin from '@/store/module/company/mixin'
import PermissionMixin from '@/store/module/permission/mixin'
export default {
  name: 'SettingsSidebar',
  mixins: [ AccountMixin, CompanyMixin, PermissionMixin ],
  data () {
    return {
      roles: Roles
    }
  },
  methods: {
    // Mesmo conserto do Sidebar.vue: o 'open' vai no li.nav-item, nao no parentElement do
    // alvo, e encolhida sem peek nao toggla (so acenderia o item sem abrir o submenu).
    handleClick (e) {
      e.preventDefault()
      const body = document.body
      if (body.classList.contains('sidebar-minimized') && !body.classList.contains('sidebar-peek')) return
      const item = e.currentTarget.closest('.nav-item')
      if (!item) return
      // Mesmo do Sidebar.vue: o aria-expanded do botao acompanha o `open` do li.
      e.currentTarget.setAttribute('aria-expanded', String(item.classList.toggle('open')))
    },
    showMenuDefault () {
      this.$emit('ReturnMenuDefault')
    }
  }
}
</script>
<style scoped>
.nav-link {
  cursor: pointer;
}
a:hover {
  text-decoration: none;
}
</style>



// WEBPACK FOOTER //
// src/containers/layout/sidebar/SettingsSidebar.vue